import { Route } from "@angular/router";

import { ProductDetailComponent } from "./components/product-detail/product-detail.component";
import { ProductListComponent } from "./components/product-list/product-list.component";
import { productDetailResolver } from "./providers/routing/product-detail-resolver";
import { productReviewsResolver } from "./providers/routing/product-reviews-resolver";
import { variantDetailResolver } from "./providers/routing/variant-detail-resolver";
import { productVariantReviewsResolver } from './providers/routing/product-variant-reviews-resolver';

export const routes: Route[] = [
    {
        path: 'c/brands',
        loadComponent: () =>
            import('./components/brands-list/brands-list.component').then((mod) => mod.BrandsListComponent),
        pathMatch: 'full',
        data: { revalidate: 5 },
    },
    {
        path: 'c/:slug',
        component: ProductListComponent,
        pathMatch: 'full',
        data: { revalidate: 5 },
    },
    {
        path: 'c/404/:slug',
        loadComponent: () =>
            import('./components/collection-not-found/collection-not-found.component').then(
                (mod) => mod.CollectionNotFoundComponent,
            ),
        data: { revalidate: null },
    },
    {
        path: 'p/:slug',
        component: ProductDetailComponent,
        resolve: { entity: productDetailResolver },
        data: { revalidate: 5 },
    },
    {
        path: 'p/404/:slug',
        loadComponent: () =>
            import('./components/product-not-found/product-not-found.component').then(
                (mod) => mod.ProductNotFoundComponent,
            ),
        data: { revalidate: null },
    },
    {
        path: 'p/:slug/reviews',
        loadComponent: () =>
            import('./components/product-reviews/product-reviews.component').then(
                (mod) => mod.ProductReviewsComponent,
            ),
        resolve: { entity: productReviewsResolver },
    },
    {
        path: 'p/:slug/reviews/submit',
        loadComponent: () =>
            import('./components/submit-product-review/submit-product-review.component').then(
                (mod) => mod.SubmitProductReviewComponent,
            ),
        resolve: { entity: productReviewsResolver },
    },
    {
        path: 'p/:slug/:sku',
        loadComponent: () =>
            import('./components/variant-detail/variant-detail.component').then(
                (mod) => mod.VariantDetailComponent,
            ),
        resolve: { entity: variantDetailResolver },
    },
    {
        path: 'p/:slug/:sku/reviews',
        loadComponent: () =>
            import('./components/product-variant-reviews/product-variant-reviews.component').then(
                (mod) => mod.ProductVariantReviewsComponent,
            ),
        resolve: { entity: productVariantReviewsResolver },
    },
    {
        path: 'p/:slug/:sku/reviews/submit',
        loadComponent: () =>
            import('./components/submit-product-review/submit-product-review.component').then(
                (mod) => mod.SubmitProductReviewComponent,
            ),
        resolve: { entity: productReviewsResolver },
    },
    {
        path: 'search',
        component: ProductListComponent,
        data: {
            isSearchPage: true,
        },
    },
];
